/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Payment = {
    paidAt: string | null;
    /**
     * Date when the payment was cancelled
     */
    cancelledAt: string | null;
    dueAt: string | null;
    /**
     * The accounting provider that initiated this payment process (if any)
     */
    accountingProviderType: Payment.accountingProviderType | null;
    /**
     * Payment processing fee (PayPal/Stripe)
     */
    feeAmount?: string | null;
    /**
     * Net amount received after provider fees
     */
    netAmount?: string | null;
    onlinePaymentMethod?: Payment.onlinePaymentMethod | null;
    /**
     * Whether provider fee was booked in accounting
     */
    feeVoucherCreated?: boolean;
    id: number;
    type: Payment.type | null;
    status: Payment.status;
    onlinePaymentUrl: string | null;
};
export namespace Payment {
    /**
     * The accounting provider that initiated this payment process (if any)
     */
    export enum accountingProviderType {
        LEXOFFICE = 'lexoffice',
        SEVDESK = 'sevdesk',
        TEBUTO = 'tebuto',
    }
    export enum onlinePaymentMethod {
        CARD = 'card',
        SEPA = 'sepa',
        PAYPAL = 'paypal',
        KLARNA = 'klarna',
        BANK_TRANSFER = 'bank_transfer',
        APPLE_PAY = 'apple_pay',
        GOOGLE_PAY = 'google_pay',
    }
    export enum type {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
    export enum status {
        OPEN = 'open',
        PENDING = 'pending',
        PAID = 'paid',
        FAILED = 'failed',
        CANCELLED = 'cancelled',
        REFUNDED = 'refunded',
    }
}

